import styled, { css } from 'styled-components';

import media from 'apps/auth/theme/media';

const CommonSelection = css`
    &::selection {
        background: ${(props) => (props.isPlastic ? props.theme.white_24_tr_base : null)} !important;
    }
`;

const CommonInfoStyle = css`
    user-select: all;
`;

const getCardBackground = (props) => {
    if (props.isPlastic && !props.isBlocked) {
        return props.theme.purple_100;
    } else if (props.isPlastic && props.isBlocked) {
        return props.theme.grey_40_lc;
    } else {
        return props.theme.white;
    }
};

const getCardBorder = (props) => {
    if (props.isPlastic && !props.isBlocked) {
        return props.theme.purple_100;
    } else if (props.isPlastic && props.isBlocked) {
        return props.theme.grey_40_lc;
    } else {
        return props.theme.black;
    }
};

const getCardCutOut = (props) => {
    if (props.isPlastic && !props.isBlocked) {
        return `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 16' width='48' height='16'%3E%3Crect fill='%23${props.theme.white_for_svg}' width='48' height='16'/%3E%3Cpath d='M48 0V16H40.8246C37.795 16 35.2579 14.0172 33.609 11.839C31.8656 9.5361 28.862 7 24 7C19.138 7 16.1344 9.5361 14.391 11.839C12.7421 14.0172 10.205 16 7.17544 16H0V0H48Z' fill='%23${props.theme.purple_100_for_svg}'/%3E%3C/svg%3E")`;
    } else if (props.isPlastic && props.isBlocked) {
        return `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 16' width='48' height='16'%3E%3Crect fill='%23${props.theme.white_for_svg}' width='48' height='16'/%3E%3Cpath d='M48 0V16H40.8246C37.795 16 35.2579 14.0172 33.609 11.839C31.8656 9.5361 28.862 7 24 7C19.138 7 16.1344 9.5361 14.391 11.839C12.7421 14.0172 10.205 16 7.17544 16H0V0H48Z' fill='%23${props.theme.grey_40_lc_for_svg}'/%3E%3C/svg%3E%0A")`;
    } else {
        return `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='48px' height='16px' viewBox='0 0 48 16'%3E%3Crect fill='%23${props.theme.white_for_svg}' width='48' height='16'/%3E%3Cpath fill='none' stroke='%23${props.theme.black_for_svg}' stroke-width='2' d='M48,15h-7.175c-2.583,0-4.859-1.705-6.418-3.765C32.539,8.769,29.27,6,24,6 s-8.539,2.769-10.406,5.235C12.035,13.295,9.758,15,7.175,15H0'/%3E%3C/svg%3E")`;
    }
};

export const CardContainer = styled.div`
    min-height: 192px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 12px;
    border-width: 2px;
    border-style: solid;
    border-color: ${(props) => getCardBorder(props)};
    position: relative;
    background: ${(props) => getCardBackground(props)};
    box-sizing: border-box;
    opacity: ${(props) => (!props.isPlastic && props.isBlocked ? '0.32' : null)};

    &:after {
        display: inline-block;
        content: '';
        position: absolute;
        left: 50%;
        margin-left: -24px;
        bottom: -2px;
        width: 48px;
        height: 16px;
        background-image: ${getCardCutOut};
    }

    ${media.mobile481} {
        min-height: 264px;
    }

    ${media.desktop1920} {
        padding: 40px 32px 32px 32px;
        min-height: 312px;
        border-radius: 16px;
    }
`;
export const DigitsRow = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${(props) => (props.isPlastic ? props.theme.white_base : props.theme.black)};
    ${CommonInfoStyle};
`;
export const DigitsGroup = styled.span`
    letter-spacing: 0.1em;
    ${CommonSelection};

    ${media.mobile481} {
        letter-spacing: 0.4em;
    }

    ${media.tablet720} {
        letter-spacing: 0.6em;
    }
`;

export const TextContainer = styled.div`
    & * {
        ${CommonInfoStyle};
        ${CommonSelection};
    }
`;

export const CvvContainer = styled.div`
    margin-left: 16px;

    & * {
        ${CommonInfoStyle};
        ${CommonSelection};
    }

    ${media.desktop1920} {
        margin-left: 32px;
    }
`;
